import React from "react";
import "./validation-error.scss";

export type ValidationErrorProps = {
  errorMessage?: string;
};

export const ValidationError: React.FC<ValidationErrorProps> = ({
  errorMessage,
}: ValidationErrorProps) => {
  return <div className="error-message">{errorMessage}</div>;
};
